'use client'

import { useCallback } from 'react'

import { useLocalStorage } from '@/shared/hooks/useLocalStorage'

const ACTIVE_JOURNEY_KEY = 'pgee.activeJourney'

interface ActiveJourneyStorage {
  journeyId: number | null
}

export const useActiveJourney = () => {
  const [activeJourney, setActiveJourney] = useLocalStorage<ActiveJourneyStorage>(
    ACTIVE_JOURNEY_KEY,
    { journeyId: null }
  )

  const setActiveJourneyId = useCallback(
    (journeyId: number | null) => {
      // Grava sincronamente: useLocalStorage persiste via useEffect, que não
      // roda se o componente desmontar na sequência (ex.: setar e navegar).
      try {
        localStorage.setItem(ACTIVE_JOURNEY_KEY, JSON.stringify({ journeyId }))
      } catch {
        // noop — storage cheio ou indisponível
      }
      setActiveJourney({ journeyId })
    },
    [setActiveJourney]
  )

  const clearActiveJourney = useCallback(() => {
    setActiveJourneyId(null)
  }, [setActiveJourneyId])

  return {
    activeJourneyId: activeJourney.journeyId,
    setActiveJourneyId,
    clearActiveJourney
  }
}
